module.exports = __webpack_public_path__ + "img/performing-arts.86cd318f.png";